import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import ReportPage from './ReportPage';

interface DashboardProps {
  isCollapsed?: boolean;
}

const Dashboard: React.FC<DashboardProps> = ({ isCollapsed }) => {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <ReportPage isCollapsed={isCollapsed ?? false} />
      </MainLayout>
    </div>
  );
};

export default Dashboard;